'use client';

import { motion } from 'framer-motion';

const SellRentBanner = () => {
    return (
        <section className="py-16 overflow-hidden">
            <div className="container-custom">
                <div className="relative rounded-[2.5rem] overflow-hidden bg-slate-900 group">
                    {/* Background Elements */}
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="absolute top-[-10%] left-[-5%] w-[40%] h-[80%] bg-violet-600/20 blur-[120px] rounded-full group-hover:bg-violet-600/30 transition-colors duration-700" />
                        <div className="absolute bottom-[-10%] right-[-5%] w-[40%] h-[80%] bg-indigo-600/20 blur-[120px] rounded-full group-hover:bg-indigo-600/30 transition-colors duration-700" />
                    </div>

                    <div className="relative px-8 py-16 md:px-16 md:py-20 flex flex-col md:flex-row items-center justify-between gap-12">
                        {/* Text Content */}
                        <div className="flex-1 text-center md:text-left">
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6 }}
                            >
                                <span className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold tracking-wider text-violet-400 uppercase bg-violet-400/10 rounded-full border border-violet-400/20">
                                    Property Owners
                                </span>
                                <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
                                    Sell or Rent Faster <br />
                                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-indigo-400">
                                        at the Right Place.
                                    </span>
                                </h2>
                                <p className="text-lg text-slate-400 mb-10 max-w-xl mx-auto md:mx-0">
                                    Reach millions of verified buyers and tenants. Get the best price for your property with DreamAcres' advanced matching technology.
                                </p>

                                <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
                                    <button className="px-8 py-4 bg-violet-600 hover:bg-violet-700 text-white font-bold rounded-2xl shadow-lg shadow-violet-600/30 transition-all duration-300 hover:scale-105 active:scale-95">
                                        Post Property for FREE
                                    </button>
                                    <button className="px-8 py-4 bg-white/5 hover:bg-white/10 text-white font-bold rounded-2xl border border-white/10 transition-all duration-300 backdrop-blur-sm">
                                        How it Works
                                    </button>
                                </div>
                            </motion.div>
                        </div>

                        {/* Stats/Visual Area */}
                        <div className="flex-1 w-full max-w-md">
                            <motion.div
                                initial={{ opacity: 0, scale: 0.9 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                                className="grid grid-cols-2 gap-4"
                            >
                                <div className="p-6 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md">
                                    <p className="text-3xl font-bold text-white mb-1">10k+</p>
                                    <p className="text-sm text-slate-400">Daily Leads</p>
                                </div>
                                <div className="p-6 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md mt-8">
                                    <p className="text-3xl font-bold text-white mb-1">5M+</p>
                                    <p className="text-sm text-slate-400">Verified Users</p>
                                </div>
                                <div className="p-6 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md">
                                    <p className="text-3xl font-bold text-white mb-1">24h</p>
                                    <p className="text-sm text-slate-400">Avg. Response</p>
                                </div>
                                <div className="p-6 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md mt-8">
                                    <p className="text-3xl font-bold text-white mb-1">0%</p>
                                    <p className="text-sm text-slate-400">Brokerage Fee</p>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SellRentBanner;
